/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeCandidateWhatsAppMessageDataSchema = z.object({
	messageType: z.string(),
	templateId: z.string().nullable().optional(),
	parameters: z.array(z.string()).nullable().optional().default([]),
	content: z.string().nullable().optional(),
})

export type StoreCandidateWhatsAppMessageDataSchema = z.infer<typeof storeCandidateWhatsAppMessageDataSchema>
